export default __webpack_public_path__ + "static/media/NeptuneDb.8869320e.svg";